import { useEffect } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Link,
  Alert,
} from '@mui/material';
import { useAuth } from '../auth';

export default function Register() {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/dashboard', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  return (
    <Box>
      <Typography variant="h5" fontWeight={600} textAlign="center" mb={3}>
        Get started
      </Typography>

      <Alert severity="info" sx={{ mb: 3 }}>
        No registration needed! Just enter your email on the login page and we'll send you a verification code.
      </Alert>

      <Typography variant="body1" textAlign="center" color="text.secondary" mb={3}>
        Our passwordless authentication means you can sign in with just your email address.
        New users are automatically registered on first login.
      </Typography>

      <Typography variant="body2" textAlign="center">
        <Link component={RouterLink} to="/login" fontWeight={600}>
          Continue to Sign In →
        </Link>
      </Typography>
    </Box>
  );
}
